export const projectTypesPT = [
   'Estratégia e futuro dos negócios',
   'Inovação corporativa e intraempreendedorismo',
   'Pesquisa e experimentação com consumidor',
   'Produtos e experiências digitais',
   'Gestão de mudança e transformação cultural',
   'Novos modelos de trabalho e processos',
  ]

export const companyAreasEN = []